import React, {Component} from "react";
import SearchTradeMarks from "./SearchTradeMarks";
import SearchHistories from "./SearchHistories";

class HomePage extends Component {
    render() {
        return (
            <div className="HomePage">
                <div className="container">
                    <div className="row">
                        <SearchTradeMarks/>
                        <SearchHistories/>
                    </div>
                </div>
            </div>
        );
    }
}

export default HomePage;


// WEBPACK FOOTER //
// ./src/app/home/HomePage.js